import React from 'react';
import Main from '../../layouts/Main';
import Head from 'next/head';
import { CANONICAL_DOMAIN } from '../../utils/constants';
import Image from 'next/image';
import AwanaImage from '../../../public/assets/awana-logo-with-clubs.png';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, Container, Typography } from '@mui/material';
import Link from 'next/link';

export default function Awana() {
  return (
    <Main header_title="Awana">
      <Head>
        <title>Fosterburg Baptist Church | Awana</title>
        <meta property="og:title" content="Fosterburg Baptist Church | Awana" key="title" />
        <link rel="canonical" href={`${CANONICAL_DOMAIN}/awana`} />
      </Head>
      <div style={{ margin: 15 }}>
        <Container maxWidth="lg">
          <Image src={AwanaImage} alt="Awana" height={180} />
          <Typography paragraph>
            Awana is a program for children ages 2 years old through 6th grade. Our focus is teaching the gospel of Christ and discipling children, so that they
            can have a relationship with God and a greater understanding of Him.
          </Typography>
          <Typography paragraph>
            We meet during the school year on Wednesday nights from 6:30-8:00. Each night, children are able to play games, sing songs, memorize scripture, and
            learn truths from the Word of God.
          </Typography>
          <div style={{ textAlign: 'center', marginTop: 35, marginBottom: 35 }}>
            <Typography variant="h6">We would love to have you join us!</Typography>
            <div style={{ marginTop: 15 }}>
              <Link href="/awana/registration" passHref>
                <Button variant="outlined" color="secondary" endIcon={<ArrowForwardIcon />}>
                  Register Here
                </Button>
              </Link>
            </div>
          </div>
        </Container>
      </div>
    </Main>
  );
}
